export const NZD = new Intl.NumberFormat("en-NZ", {
  style: "currency",
  currency: "NZD",
});

export const NZ_GST = 0.15;
export const ADD_NZ_GST = 1.15;
